<div class="row" class="option-list">
  <div class="col-12">
    <nb-accordion>
      <nb-accordion-item class="option-list" [expanded]="true">
        <nb-accordion-item-header>
          <strong>Available options</strong>
        </nb-accordion-item-header>
        <nb-accordion-item-body cdkDropList (cdkDropListDropped)="drop($event)" *ngIf="elementValues.controls">
          <nb-card *ngFor="let elementValue of elementValues.controls; let i = index" cdkDrag>
            <nb-card-header class="form-elements-header">
              <div class="drag-title">
                <nb-actions size="tiny">
                  <nb-action class="p-0">
                    <mat-icon cdkDragHandle class="ml-3"> drag_indicator </mat-icon>
                  </nb-action>
                </nb-actions>
                <ngx-personas-form-element-value
                  [name]="elementValue.controls['name']"
                  [slug]="elementValue.controls['slug']"
                  [slugs]="slugs"
                  (enterPressed)="handleEnter(i)"
                  [id]="identifier + i"
                ></ngx-personas-form-element-value>
              </div>
              <nb-actions size="tiny">
                <nb-action (click)="deleteFieldValue(i)">
                  <nb-icon icon="trash" status="danger"></nb-icon>
                </nb-action>
              </nb-actions>
            </nb-card-header>
          </nb-card>
          <button nbButton fullWidth (click)="addFieldValue()" status="basic" class="my-2 d-flex flex-row align-content-center add-field-button" type="button" role="button">
            <span class="fas fa-plus fa-md mx-2"></span>
            Add an option
          </button>
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>
  </div>

  <div class="col-12"></div>
</div>
